import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/JwtService";
import { number } from "yup";
/**
 * @description service to call HTTP request via Axios
 */
class fornecService {
    /**
     * @description initialize vue axios
     */
    static init(app) {
        fornecService.vueInstance = app;
        if (!fornecService.vueInstance.axios)
            fornecService.vueInstance.use(VueAxios, axios);
        fornecService.BaseUrl = import.meta.env.VITE_FORNEC_URL;
    }
    /**
     * @description set the default HTTP request headers
    */
    static setHeader() {
        fornecService.vueInstance.axios.defaults.headers.common["Authorization"] = "Bearer " + JwtService.getToken();
        fornecService.vueInstance.axios.defaults.headers.common["Accept"] =
            "application/json";
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static query(resource, params) {
        return fornecService.vueInstance.axios.get(`${fornecService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static get(resource, slug = "") {
        return fornecService.vueInstance.axios.get(`${fornecService.BaseUrl}/${resource}/${slug}`);
    }
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static post(resource, params) {
        return fornecService.vueInstance.axios.post(`${fornecService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the PUT HTTP request
    * @param resource: string
    * @param params: AxiosRequestConfig
    * @returns Promise<AxiosResponse>
    */
    static put(resource, params) {
        return fornecService.vueInstance.axios.put(`${fornecService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the DELETE HTTP request
    * @param resource: string
    * @param slug: number
    * @returns Promise<AxiosResponse>
    */
    static delete(resource, slug = number) {
        return fornecService.vueInstance.axios.delete(`${fornecService.BaseUrl}/${resource}/${slug}`);
    }
    /**
    * @description set the POST HTTP request
    * @param resource: string
    * @param params: AxiosRequestConfig
    * @returns Promise<AxiosResponse>
    */
    static postForm(resource, params) {
        return fornecService.vueInstance.axios.post(`${fornecService.BaseUrl}/${resource}`, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}
export default fornecService;
//********** COMENTÁRIO GERADO EM: 25/06/2024 01:38:43 **********
//
//import { App } from "vue";
//import axios from "axios";
//import VueAxios from "vue-axios";
//import JwtService from "@/core/services/JwtService";
//import { AxiosResponse, AxiosRequestConfig } from "axios";
//import { number } from "yup";
//
///**
// * @description service to call HTTP request via Axios
// */
//class fornecService {
//    /**
//     * @description property to share vue instance
//     */
//    public static vueInstance: App;
//    private static BaseUrl;
//
//    /**
//     * @description initialize vue axios
//     */
//    public static init(app: App<Element>) {
//        fornecService.vueInstance = app;
//        fornecService.vueInstance.use(VueAxios, axios);
//        //fornecService.vueInstance.axios.defaults.baseURL = import.meta.env.VITE_fornec_URL;
//        fornecService.BaseUrl = import.meta.env.VITE_FORNEC_URL;
//    }
//
//    /**
//     * @description set the default HTTP request headers
//    */
//    public static setHeader(): void {
//        fornecService.vueInstance.axios.defaults.headers.common[
//            "Authorization"
//        ] = "Bearer " + JwtService.getToken();
//        fornecService.vueInstance.axios.defaults.headers.common["Accept"] =
//            "application/json";
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static query(
//        resource: string,
//        params: AxiosRequestConfig
//
//    ): Promise<AxiosResponse> {
//        return fornecService.vueInstance.axios.get(`${fornecService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param slug: string
//     * @returns Promise<AxiosResponse>
//     */
//    public static get(
//        resource: string,
//        slug = "" as string
//    ): Promise<AxiosResponse> {
//        return fornecService.vueInstance.axios.get(`${fornecService.BaseUrl}/${resource}/${slug}`);
//    }
//
//    /**
//     * @description set the POST HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static post(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return fornecService.vueInstance.axios.post(`${fornecService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//    * @description Send the PUT HTTP request
//    * @param resource: string
//    * @param params: AxiosRequestConfig
//    * @returns Promise<AxiosResponse>
//    */
//    public static put(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return fornecService.vueInstance.axios.put(`${fornecService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//    * @description Send the DELETE HTTP request
//    * @param resource: string
//    * @param slug: number
//    * @returns Promise<AxiosResponse>
//    */
//    public static delete(
//        resource: string,
//        slug = number
//    ): Promise<AxiosResponse> {
//        return fornecService.vueInstance.axios.delete(`${fornecService.BaseUrl}/${resource}/${slug}`);
//    }
//
//    /**
//    * @description set the POST HTTP request
//    * @param resource: string
//    * @param params: AxiosRequestConfig
//    * @returns Promise<AxiosResponse>
//    */
//    static postForm(resource, params) {
//        return fornecService.vueInstance.axios.post(`${fornecService.BaseUrl}/${resource}`, params, {
//            headers: {
//                'Content-Type': 'multipart/form-data'
//            }
//        });
//    }
//
//}
//
//export default fornecService;
//
//
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=fornecService.js.map